export const ZONE_TYPE_ABSTRACT = 'Zone';
export const ZONE_TYPE_BOX = 'BoxZone';
export const ZONE_TYPE_LINE = 'LineZone';
export const ZONE_TYPE_MESH = 'MeshZone';
export const ZONE_TYPE_POINT = 'PointZone';
export const ZONE_TYPE_SCREEN = 'ScreenZone';
export const ZONE_TYPE_SPHERE = 'SphereZone';
